import useSWR, { type SWRConfiguration } from 'swr';
import denApi from '@/lib/api/denApi';
import { Account } from '@mls-wallet/shared-types';

const accountFetcher = async (url: string): Promise<Account> =>
  await denApi.get<Account, void>(url);

// Hook for fetching a specific account by ID.
export function useAccount(
  accountId: string,
  swrOptions?: SWRConfiguration<Account>
) {
  const { data, error, isLoading, mutate } = useSWR<Account>(
    `multichain-account/${accountId}`,
    accountFetcher,
    { revalidateOnFocus: false, ...(swrOptions ?? {}) }
  );

  return {
    account: data ?? null,
    isLoading,
    error,
    refresh: mutate,
  };
}
